export default __webpack_public_path__ + "static/media/errorTriangle.9f3b57e4.svg";